import React, { createContext, useContext, useState, useCallback } from 'react';

const QuizContext = createContext();

export const QuizProvider = ({ children }) => {
  const [isQuizActive, setIsQuizActive] = useState(false);
  const [showExitModal, setShowExitModal] = useState(false);
  const [pendingAction, setPendingAction] = useState(null);

  const setQuizActive = useCallback((active) => {
    setIsQuizActive(active);
  }, []);

  const requestNavigation = useCallback((action) => {
    if (isQuizActive) {
      setPendingAction(() => action);
      setShowExitModal(true);
      return false; // Navigation blocked
    }
    return true; // Navigation allowed
  }, [isQuizActive]);

  const confirmExit = useCallback(() => {
    setShowExitModal(false);
    setIsQuizActive(false);
    if (pendingAction) {
      pendingAction();
      setPendingAction(null);
    }
  }, [pendingAction]);

  const cancelExit = useCallback(() => {
    setShowExitModal(false);
    setPendingAction(null);
  }, []);

  return (
    <QuizContext.Provider
      value={{
        isQuizActive,
        setQuizActive,
        showExitModal,
        requestNavigation,
        confirmExit,
        cancelExit
      }}
    >
      {children}
    </QuizContext.Provider>
  );
};

export const useQuiz = () => {
  const context = useContext(QuizContext);
  if (!context) {
    throw new Error('useQuiz must be used within a QuizProvider');
  }
  return context;
};

export default QuizContext;
